/**
 * Many times throughout the application we are using .splice()
 * in underlying methods to mutate the array.
 * When you remove all the items in the array with .splice()
 * .splice() only explicitly sets the length of the array to 0, and doesn't
 * set the value explicitly. Our custom setter
 * is expected it to set the value, so we are using a "copy"
 * array as a reference which can keep tabs on the expected value
 * and and trigger changes as expected.
 */
export default class TrackedArrayProxy {
  static create(target: { parent: any, key: PropertyKey }): ProxyConstructor {
    (<any>target).copy = (<any>target).slice();
    return new Proxy(target, TrackedArrayProxy.trackedArrayHandler);
  }
  static trackArray(target, property, value) {
    if (target[property] === value) {
      return;
    }
    if (target.shouldTrack) {
      const currentValueArr = Object.assign(target.copy.slice(), {parent: target.parent, key: target.key, shouldTrack: false})
      const currentValue = TrackedArrayProxy.create(currentValueArr)
      target[property] = value;
      if (target.parent._track !== false) {
        target.parent.trackChange(target.key, currentValue, target);
      }
      target.__ob__.dep.notify();
    }
    // prevents tracking on initial load
    target.shouldTrack = true;
  }
  static trackedArrayHandler = {
    get: function (target, property) {
      // property is index in this case
      return target[property];
    },
    set: function (target, property, value, receiver) {
      TrackedArrayProxy.trackArray(target, property, value);
      target.copy[property] = value;
      // you have to return true to accept the changes
      return true;
    }
  };
}